import { PurchaseOrderStatusInterface } from '@app/interfaces/purchase-order-status.model';

import { IBinLocation } from '../../location/interfaces/location.interface';
import { IWarehouse } from '../../shared/interfaces/location-warehouse.interface';
import { IUnitOfMeasure } from '../../unit-of-measure';

import { IRfq } from './../../rfq/interfaces/rfq.interface';
import { IPagination } from './../../shared/interfaces/paginator.interface';

export interface IPurchaseOrderState {
  currentQueryParams :{ [key :string] :string | string[] };
  currentShipment :any; // TODO: Define the type
  loadingShipments :boolean;
  loadingPurchaseOrders :boolean;
  loadingCurrentShipment :boolean;
  meta :IPagination | null;
  purchaseOrders :any[]; // TODO: Define the type
  shipments :IPurchaseOrderShipment[];
  shipmentStatus :PurchaseOrderStatusInterface[];
  submitting :boolean;
}

export interface IPurchaseOrder {
  id :number;
  factory ?:any;
  purchase_order_items :IPurchaseOrderItem[];
  total_receive_per_rfqs :IReceivedPerRfqItem[];
  arrival_due_date :string;
  warehouse_id :number;
  warehouse :IWarehouse;
  location :IBinLocation;
  default_ship_to_address :string;
  default_receiving_location :IBinLocation;
}

export interface IPurchaseOrderItem {
  id :number;
  internal_sku :string;
  product_name :string;
  unit_price :number;
  quantity :number;
  addToReceiveQty ?:number;
  ordered_uom_id :number;
  unit :string;
  rfq_id :number;
  rfq :any;
  lot_id :number;
  lot :any;
  purchaseOrder :IPurchaseOrder;
  ordered_unit_of_measure :IUnitOfMeasure;
}

export interface IReceivedPerRfqItem {
  id :number;
  purchase_order_rfq_id :number;
  quantity :number;
}

export interface IPurchaseOrderItemBulkUpdateDetails {
  purchasePrice ?:number;
  purchaseQty ?:number;
  addToReceivingQty ?:number;
}

export interface IPurchaseOrderShipment {
  id :number;
  createdAt :string;
  updatedAt :string;
  warehouseId :number;
  referenceNumber :string;
  totalShippingCost :number;
  shippingDate :Date;
  shipmentItems :IPurchaseOrderShipmentShipmentItem[];
  shipmentExtraCosts :IPurchaseOrderShipmentShipmentExtraCost[];
  shipmentStatus :IPurchaseOrderShipmentStatus;
}

export interface IPurchaseOrderShipmentStatus {
  id :number;
  name :string;
  leadTimeDays :number;
}

export interface IPurchaseOrderShipmentShipmentExtraCost {
  id :number;
  createdAt :string;
  updatedAt :string;
  supplierPurchaseOrderShipmentId :number;
  name :string;
  quantity :number;
  unitPrice :number;
  lineTotal :number;
  costAllocationType ?:string;
}

export interface IPurchaseOrderShipmentShipmentItem {
  id :number;
  createdAt :string;
  updatedAt :string;
  supplierPurchaseOrderShipmentId :number;
  supplierPurchaseOrderId :number;
  supplierPurchaseOrderItemId :number;
  supplierPurchaseOrderItem :IPurchaseOrderShipmentSupplierPurchaseOrderItem;
  quantity :number;
  unitOfMeasureId :number;
  unitOfMeasure :IUnitOfMeasure;
}

export interface IPurchaseOrderShipmentSupplierPurchaseOrderItem {
  id :number;
  createdAt :string;
  updatedAt :string;
  status :string;
  supplierPurchaseOrderId :number;
  internalSku :string;
  sourceSku :string;
  productName :string;
  productDescription :string;
  quantity :number;
  unit :string;
  variantJson ?:any;
  variantLabel ?:any;
  variantValue ?:any;
  unit_Price :number;
  tax :number;
  discountAmount :number;
  discountPercent :number;
  downPaymentAmount :number;
  downPaymentPercent :number;
  lineTotal :number;
  rfqId :number;
  rfq :IRfq;
  productTypeId :number;
  shippingUnitCost :number;
  stockId :number;
  order ?:any;
  orderedQuantity :number;
  baseUomId :number;
  orderedUomId :number;
  receivedQuantity :number;
  description ?:any;
  internalResourceItemId ?:any;
  internalResourceItemType ?:any;
  lotId ?:any;
}

export enum PurchaseOrderItemField {
  PURCHASE_PRICE = 'purchasePrice',
  PURCHASE_QTY = 'purchaseQty',
  ADD_TO_RECEIVING_QTY = 'addToReceivingQty',
  LOT_ID = 'lotId',
}
